import Immutable, { List, Record, Map } from 'immutable';

import traintime from '../lib/TrainTime';
import config from '../config';
import { unique } from '../helpers/Immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const JourneyNotificationState = new Record({
    latestMessages: new List(),
    dismissed: new List()
});

export class JourneyNotificationStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.JOURNEY_NOTIFICATIONS_LOADED]: this.handleJourneyNotificationsLoaded,
            [ActionTypes.JOURNEY_NOTIFICATIONS_DISMISSED]: this.handleJourneyNotificationsDismissed
        };
    }

    deserialize (serialized) {
        if (serialized) {
            return new JourneyNotificationState({ dismissed: Immutable.fromJS(serialized.dismissed) });
        }
        return new JourneyNotificationState();
    }

    serialize () {
        const now = traintime();
        const notExpired = this.state.dismissed.filter(
            (dismissedMessage) => traintime(dismissedMessage.get('expiry')).isAfter(now)
        );
        const uniqueDismissed = unique(notExpired, (journeyNotification) => journeyNotification.get('id'));

        return {
            dismissed: uniqueDismissed.toJS()
        };
    }

    handleJourneyNotificationsLoaded ({ messages }) {

        const now = traintime();
        const notExpired = this.state.dismissed.filter(
            (dismissedMessage) => traintime(dismissedMessage.get('expiry')).isAfter(now)
        );

        this.setState(
            this.state.set('dismissed', notExpired)
        );

        const filteredMessages = messages.filter((message) => !this.isJourneyNotificationDismissed(message.id));

        this.setState(
            this.state.set('latestMessages', filteredMessages)
        );
    }

    handleJourneyNotificationsDismissed () {
        const { latestMessages, dismissed } = this.state;
        if (latestMessages.size > 0) {
            const expires = config.get('journeyNotificationDismissExpires') || 3600;
            const dismissedMessages = latestMessages.map(
                message => new Map({
                    id: message.id,
                    expiry: traintime().add(expires, 'seconds').format()
                })
            );
            this.setState(
                this.state.set('dismissed', dismissed.concat(dismissedMessages)).set('latestMessages', new List())
            );
        }
    }

    isJourneyNotificationDismissed (messageId) {
        const dismissed = this.state.dismissed.find(
            (dismissedMessage) => dismissedMessage.get('id') === messageId
        );
        if (dismissed) {
            return traintime(dismissed.get('expiry')).isAfter(traintime());
        }
        return false;
    }
}

let storeInstance = new JourneyNotificationStore('journey-notification');

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/JourneyNotificationStore.js